import { render, staticRenderFns } from "./ProductImages.vue?vue&type=template&id=6f2efa69&scoped=true&"
import script from "./ProductImages.vue?vue&type=script&lang=js&"
export * from "./ProductImages.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/product/ProductImages/ProductImagesStyle.css?vue&type=style&index=0&id=6f2efa69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2efa69",
  null
  
)

export default component.exports